import {
    CATEGORY_TICKET_DATA,
    CATEGORY_SUBCATEGORY_DATA, 
    CATEGORY_SUBCATEGORY_CONFIG_DATA, 
    CATEGORY_GET_DATA,
    CATEGORY_FORM_ADD_DATA,
    CATEGORY_UPDATE_DATA,
    CATEGORY_DELETE_DATA,
    CATEGORY_GET_ALL_DATA,
    CATEGORY_UPDATE_ALL_DATA,
    CATEGORY_DELETE_ALL_DATA,    
    
} from './Constants'

// get all category listing
const loadCategoryTicketDataRequest = () => ({
  type: CATEGORY_TICKET_DATA.CATEGORY_TICKET_DATA_LOAD,
});
const setCategoryTicketDataSuccess = (categorylist) => ({
  type: CATEGORY_TICKET_DATA.CATEGORY_TICKET_DATA_SUCCESS,
  categorylist,
});
const setCategoryTicketDataFail = (error) => ({
  type: CATEGORY_TICKET_DATA.CATEGORY_TICKET_DATA_FAIL,
  error,
});

// get all category
const loadCategorySubCategoryDataRequest = () => ({
  type: CATEGORY_SUBCATEGORY_DATA.CATEGORY_SUBCATEGORY_DATA_LOAD,
});
const setCategorySubCategoryDataSuccess = (categories) => ({
  type: CATEGORY_SUBCATEGORY_DATA.CATEGORY_SUBCATEGORY_DATA_SUCCESS,
  categories,
});
const setCategorySubCategoryDataFail = (error) => ({
  type: CATEGORY_SUBCATEGORY_DATA.CATEGORY_SUBCATEGORY_DATA_FAIL,
  error,
});

// get all category with config id
const loadCategorySubCategoryConfigDataRequest = () => ({
  type: CATEGORY_SUBCATEGORY_CONFIG_DATA.CATEGORY_SUBCATEGORY_CONFIG_DATA_LOAD,
});
const setCategorySubCategoryConfigDataSuccess = (categoryconfig) => ({
  type: CATEGORY_SUBCATEGORY_CONFIG_DATA.CATEGORY_SUBCATEGORY_CONFIG_DATA_SUCCESS,
  categoryconfig,
});
const setCategorySubCategoryConfigDataFail = (error) => ({
  type: CATEGORY_SUBCATEGORY_CONFIG_DATA.CATEGORY_SUBCATEGORY_CONFIG_DATA_FAIL,
  error,
});

//Get by id
const loadCategoryGetDataRequest = (id) => ({
  type: CATEGORY_GET_DATA.CATEGORY_GET_DATA_LOAD,
  id,
});

const setCategoryGetDataSuccess = (category) => ({
  type: CATEGORY_GET_DATA.CATEGORY_GET_DATA_SUCCESS,
  category,
});

const setCategoryGetDataFail = (error) => ({
  type: CATEGORY_GET_DATA.CATEGORY_GET_DATA_FAIL,
  error,
});

//For add  cate
const loadCategoryFormAddDataRequest = (request) => ({
  type: CATEGORY_FORM_ADD_DATA.CATEGORY_FORM_ADD_DATA_LOAD,
  request,
});
const setCategoryFormAddDataSuccess = (categoryform) => ({
  type: CATEGORY_FORM_ADD_DATA.CATEGORY_FORM_ADD_DATA_SUCCESS,
  categoryform,
});
const setCategoryFormAddDataFail = (error) => ({
  type: CATEGORY_FORM_ADD_DATA.CATEGORY_FORM_ADD_DATA_FAIL,
  error,
});


//For Edit cate
const loadCategoryUpdateDataRequest = (request) => ({
  type: CATEGORY_UPDATE_DATA.CATEGORY_UPDATE_DATA_LOAD,
  request
})

const setCategoryUpdateDataSuccess = (category) => ({
  type: CATEGORY_UPDATE_DATA.CATEGORY_UPDATE_DATA_SUCCESS,
  category,
})

const setCategoryUpdateDataFail = (error) => ({
  type: CATEGORY_UPDATE_DATA.CATEGORY_UPDATE_DATA_FAIL,
  error
})

const resetCategoryFormUpdateData = () => ({
  type: CATEGORY_UPDATE_DATA.CATEGORY_UPDATE_DATA_RESET,
});


// Delete cate
const loadCategoryDeleteDataRequest = (id) => ({
  type: CATEGORY_DELETE_DATA.CATEGORY_DELETE_LOAD,
  id,
});
const setCategoryDeleteDataSuccess = (category) => ({
  type: CATEGORY_DELETE_DATA.CATEGORY_DELETE_SUCCESS,
  category,
});

const setCategoryDeleteDataFail = (error) => ({
  type: CATEGORY_DELETE_DATA.CATEGORY_DELETE_FAIL,
  error,
});
// get all category listing
const loadCategoryGetAllDataRequest = () => ({
  type: CATEGORY_GET_ALL_DATA.CATEGORY_GET_ALL_DATA_LOAD,
});
const setCategoryGetAllDataSuccess = (allcategories) => ({
  type: CATEGORY_GET_ALL_DATA.CATEGORY_GET_ALL_DATA_SUCCESS,
  allcategories,
});
const setCategoryGetAllDataFail = (error) => ({
  type: CATEGORY_GET_ALL_DATA.CATEGORY_GET_ALL_DATA_FAIL,
  error,
});
// Update category or subcategory
const loadCategoryUpdateAllDataRequest = (request) => ({
  type: CATEGORY_UPDATE_ALL_DATA.CATEGORY_UPDATE_ALL_DATA_LOAD,
  request,
});
const setCategoryUpdateAllDataSuccess = (data) => ({
  type: CATEGORY_UPDATE_ALL_DATA.CATEGORY_UPDATE_ALL_DATA_SUCCESS,
  data,
});
const setCategoryUpdateAllDataFail = (error) => ({
  type: CATEGORY_UPDATE_ALL_DATA.CATEGORY_UPDATE_ALL_DATA_FAIL,
  error,
});

// Delete category or subcategory
const loadCategoryDeleteAllDataRequest = (id, action, entityType) => ({
  type: CATEGORY_DELETE_ALL_DATA.CATEGORY_DELETE_ALL_LOAD,
  id,
  action,       
  entityType,   
});
const setCategoryDeleteAllDataSuccess = (data) => ({
  type: CATEGORY_DELETE_ALL_DATA.CATEGORY_DELETE_ALL_SUCCESS,
  data,
});
const setCategoryDeleteAllDataFail = (error) => ({
  type: CATEGORY_DELETE_ALL_DATA.CATEGORY_DELETE_ALL_FAIL,
  error,
});



export {
    loadCategoryTicketDataRequest,setCategoryTicketDataFail,setCategoryTicketDataSuccess,
    loadCategorySubCategoryDataRequest,setCategorySubCategoryDataFail,setCategorySubCategoryDataSuccess,
    loadCategorySubCategoryConfigDataRequest, setCategorySubCategoryConfigDataSuccess,setCategorySubCategoryConfigDataFail,
    loadCategoryGetDataRequest,setCategoryGetDataFail,setCategoryGetDataSuccess,
    loadCategoryFormAddDataRequest,setCategoryFormAddDataFail,setCategoryFormAddDataSuccess,
    loadCategoryUpdateDataRequest, setCategoryUpdateDataFail, setCategoryUpdateDataSuccess,
    loadCategoryDeleteDataRequest, setCategoryDeleteDataFail, setCategoryDeleteDataSuccess,
    resetCategoryFormUpdateData,
    loadCategoryGetAllDataRequest, setCategoryGetAllDataFail, setCategoryGetAllDataSuccess,
    loadCategoryUpdateAllDataRequest, setCategoryUpdateAllDataSuccess, setCategoryUpdateAllDataFail,
    loadCategoryDeleteAllDataRequest, setCategoryDeleteAllDataSuccess, setCategoryDeleteAllDataFail,
}